module.exports = __webpack_public_path__ + "static/media/tip-4.34092f52.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/tip-4.jpeg
// module id = 540
// module chunks = 0